import React from 'react';
import { PhoneIcon } from 'lucide-react';
import { WhatsAppIcon } from './icons/WhatsAppIcon';
import { business } from '../data/site';
import { useLanguage } from '../contexts/LanguageContext';
import { ui } from '../data/ui';
export function WhatsAppFloat() {
  const {
    t
  } = useLanguage();
  return <>
      <div className="fixed bottom-5 right-5 z-50 hidden sm:block" data-id="element-356" data-mp="24x0vd5ynf6mo">
        <a href={business.whatsappHref} target="_blank" rel="noreferrer" className="group flex items-center gap-3 rounded-full bg-[#25D366] py-3 pl-3 pr-4 shadow-lift transition-colors duration-150 ease-out-expo hover:bg-[#1FBB59]" aria-label={`${t(ui.whatsapp)} ${business.phoneDisplay}`} data-id="element-357" data-mp="32jzvxrsgoypu">
          <span className="flex h-9 w-9 items-center justify-center rounded-full bg-white/25" data-id="element-358" data-mp="2nukbetjixpil">
            <WhatsAppIcon className="h-5 w-5 text-[#0B3B22]" data-id="element-359" data-mp="3lb96m4dyxtj0" />
          </span>
          <span className="text-sm font-semibold text-[#0B3B22]" data-id="element-360" data-mp="3gjhjy4xxo7y5">{t(ui.whatsapp)}</span>
        </a>
      </div>

      <div className="fixed inset-x-0 bottom-0 z-50 grid grid-cols-2 border-t border-white/10 sm:hidden" data-id="element-361" data-mp="3gal12fldwl8f">
        <a href={business.phoneHref} className="flex items-center justify-center gap-2 bg-navy py-3.5 text-sm font-semibold text-white" data-id="element-362" data-mp="3k9ljhwzy9luw">
          <PhoneIcon className="h-4 w-4 text-gold" aria-hidden="true" data-id="element-363" data-mp="3bi1ljd34zg0z" />
          {t(ui.callNow)}
        </a>
        <a href={business.whatsappHref} target="_blank" rel="noreferrer" className="flex items-center justify-center gap-2 bg-[#25D366] py-3.5 text-sm font-semibold text-[#0B3B22]" data-id="element-364" data-mp="2wl14c3ikn3gr">
          <WhatsAppIcon className="h-4 w-4" data-id="element-365" data-mp="2nm75e6hrq101" />
          WhatsApp
        </a>
      </div>
    </>;
}